import Vue from 'vue';
import Helpers from 'Modules/Helpers';

export default class InitComponent {
  constructor ({ selectors, components, template, data = {}, store = null, methods = null, beforeCreate = null }) {
    this.selectorsAreIterable = Helpers.isIterable(selectors);

    if (!selectors || (this.selectorsAreIterable && !selectors.length)) {
      return;
    }

    this.selectors = selectors;
    this.component = components;
    this.data = data;
    this.template = template;
    this.store = store;
    this.methods = methods;
    this.beforeCreate = beforeCreate;
  }

  singleInit = (selector) => new Vue(
    {
      el: selector,
      components: this.component,
      data: this.data,
      template: this.template,
      store: this.store,
      methods: this.methods,
      beforeCreate: this.beforeCreate
    }
  );

  init () {
    if (!this.selectors) {
      return;
    }

    this.selectorsAreIterable
      ? [...this.selectors].forEach(selector => this.singleInit(selector))
      : this.singleInit(this.selectors);
  }
}
